import script from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"

import "./UpdateNotification.vue?vue&type=style&index=0&id=5e02dac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e02dac8"]])

export default __exports__